<template>
  <div class="card">
    <div class="card-image">
      <figure class="image">
        <img v-bind:src="'/api/images/' + gallery.representative + '/thumb'" class="ii-image">
      </figure>
    </div>
    <div class="card-content">
      <h3 class="title is-size-4">
        {{ gallery.name }}
      </h3>
      <table class="imageinfo-table">
        <tbody>
          <tr v-if="friendsById[gallery.userID]">
            <th>Besitzer:</th>
            <td>{{ friendsById[gallery.userID].name }}</td>
          </tr>
          <tr>
            <th>Von:</th>
            <td>{{ gallery.startDate.toLocaleString("de") }}</td>
          </tr>
          <tr>
            <th>Bis:</th>
            <td>{{ gallery.endDate.toLocaleString("de") }}</td>
          </tr>
          <tr>
            <th>Anzahl Bilder:</th>
            <td>{{ gallery.imageIds.length }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState} from 'vuex';
export default {
  props: ["gallery"],
  data() {
    return {
      objectUrl: undefined,
      orientation: -2
    };
  },
  computed: {
    ...mapState(['friendsById'])
  },
  mounted() {
    const config = {
      treshold: 1
    };
  },
  destroyed() {
    if (this.objectUrl) {
      //console.log("revoking ", this.image.fileObject.name);
      window.URL.revokeObjectURL(this.objectUrl);
    }
  },
  methods: {
    onload(e) {}
  }
};
</script>